import React from "react";

import { Button, Stack } from "@mui/material";

const buttonSx = { borderRadius: "32px", textTransform: "none", minWidth: 72 } as const;

interface PromptFooterProps {
  onCancel: () => void;
  onApply: () => void;
  applyLabel?: string;
}

export const PromptFooter: React.FC<PromptFooterProps> = ({ onCancel, onApply, applyLabel = "Apply" }) => (
  <Stack direction="row" justifyContent="flex-end" gap="8px">
    <Button variant="outlined" size="sm" onClick={onCancel} sx={buttonSx}>
      Cancel
    </Button>
    <Button variant="contained" size="sm" onClick={onApply} sx={{ ...buttonSx, bgcolor: "#0a3142" }}>
      {applyLabel}
    </Button>
  </Stack>
);
